import './style.css';
import {AnimatePresence, motion} from 'framer-motion';
import BudgetButton from '../BudgetButton';
import logoFacebook from '../../assets/images/facebook-logo.png';
import logoInstagram from '../../assets/images/instagram-logo.png';
import logo from '../../assets/icons/logo.svg';
import {scrollToContact} from '../../assets/scroll';
import {Link} from 'react-router-dom';

const transition = {ease: "easeIn", duration: 0.1 }

function Sidebar({handleClick, isOpened}){
    return <AnimatePresence >
        {isOpened && 
        <motion.div className="sidebar-backdrop" animate={{ x: 0 }} initial={{x: '-100vw'}} exit={{x: '-100vw'}} transition={transition} exitBeforeEnter>
            <div className="sidebar-wrapper">
                <img className="top-header-logo" src={logo} alt="todo-bolson"/>
                <ul>
                    <li onClick={handleClick}><Link to="/">Inicio</Link></li>
                    <li onClick={scrollToContact}>Nosotros/Contacto</li>
                    <li onClick={handleClick}><Link to="/productos">Productos</Link></li>
                    <li onClick={handleClick}><Link to="/consejos">Consejos</Link></li>
                    <li onClick={handleClick}><Link to="/varios">Varios</Link></li>
                    <li onClick={handleClick}><BudgetButton/></li>
                </ul>
                <h4>Seguinos en: 
                    <a href="https://www.facebook.com/todobolsonsas/" target="_blank"><img alt="" src={logoFacebook} width="25px" /></a>
                    <a href="https://www.instagram.com/todobolson/" target="_blank"><img alt="" src={logoInstagram} width="25px"/></a>
                </h4>               
            </div>
            <div className="sidebar-space" onClick={()=>handleClick()}></div>
        </motion.div>}
    </AnimatePresence>
}

export default Sidebar;